import React from "react";
import PropTypes from "prop-types";

import pluralize from "pluralize";
import { Icon, Segment } from "semantic-ui-react";

import Form from "components/Form";

function ProcessField({ process, disabled }) {
  return (
    <Segment
      size="small"
      textAlign="left"
      style={{
        display: "grid",
        gridTemplateColumns: "5% 75% 20%",
        padding: "0.5em",
        margin: "0 0 0.5em 0",
      }}
    >
      <Form.Checkbox
        name={`processes.${process.id}`}
        toggle={false}
        hideError
        disabled={disabled}
      />
      <label
        htmlFor={`processes.${process.id}`}
        title={process.name}
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          borderRight: "1px solid #dedede",
        }}
      >
        {process.name}
      </label>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginLeft: "0.5em",
        }}
      >
        <Icon name="align left" style={{ transform: "rotate(90deg)" }} />

        <span>
          {process.numWorkflows || 0}&nbsp;
          {pluralize("Workflow", process.numWorkflows)}
        </span>
      </div>
    </Segment>
  );
}

ProcessField.propTypes = {
  process: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    numWorkflows: PropTypes.number,
  }).isRequired,
  disabled: PropTypes.bool,
};

ProcessField.defaultProps = { disabled: false };

export default ProcessField;
